import { render, staticRenderFns } from "./TarifaAdicionalIndex.vue?vue&type=template&id=e1a0254a"
import script from "./TarifaAdicionalIndex.vue?vue&type=script&lang=js"
export * from "./TarifaAdicionalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports